import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import api from '../../services/api';

const CallsHistory = ({ direction = 'outgoing' }) => {
  const [stats, setStats] = useState({ summary: {}, details: [] });
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState('today');
  const [bNumber, setBNumber] = useState('');
  const [onlyNzero, setOnlyNzero] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    loadStats();
  }, [period, direction, refreshTrigger]);

  const loadStats = async () => {
    setLoading(true);
    try {
      const endpoint =
        direction === 'outgoing'
          ? '/statistics/voice-outgoing'
          : '/statistics/voice-incoming';
      const params = new URLSearchParams({
        period,
        b_number: bNumber,
        only_nzero: onlyNzero,
      });
      const response = await api.get(`${endpoint}?${params}`);
      setStats(response.data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    loadStats();
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return `${mins} min ${secs} sec`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // === Генерація кнопок з датами ===
  const today = new Date();
  const dateButtons = [
    { key: 'last_hour', label: 'Last Hour' },
    { key: 'today', label: 'Today' },
    { key: 'yesterday', label: 'Yesterday' },
  ];

  for (let i = 2; i <= 7; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    const label = d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
    });
    dateButtons.push({ key: `day_${i}`, label });
  }

  const { summary, details } = stats;

  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h4>
            Calls history {direction}, today is{' '}
            {new Date().toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
            })}
          </h4>
        </Card.Header>
        <Card.Body>
        <Row className="mb-3 align-items-end">
  <Col md={3}>
    <Form.Group>
      <Form.Label>B number:</Form.Label>
      <Form.Control
        type="text"
        placeholder="Enter B number"
        value={bNumber}
        onChange={(e) => setBNumber(e.target.value)}
      />
      <Form.Check
        type="checkbox"
        label="Only Nzero calls"
        checked={onlyNzero}
        onChange={(e) => setOnlyNzero(e.target.checked)}
        className="mt-2"
      />
    </Form.Group>
  </Col>

  <Col md={9}>
    <div className="d-flex gap-2 flex-wrap justify-content-start mt-4">
      {dateButtons.map((btn) => (
        <Button
          key={btn.key}
          size="sm"
          variant={period === btn.key ? 'primary' : 'outline-primary'}
          onClick={() => {
            setPeriod(btn.key);
            setRefreshTrigger((prev) => prev + 1);
          }}
        >
          {btn.label}
        </Button>
      ))}
    </div>
  </Col>
</Row>


          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className="bg-success text-white p-3 mb-3 rounded d-flex justify-content-between flex-wrap">
                <div>
                  <strong>Total Duration:</strong>{' '}
                  {summary.duration || '0.00'} minutes
                  {summary.good_total && (
                    <span className="ms-3">
                      <strong>Good/Total:</strong> {summary.good_total}
                    </span>
                  )}
                  {summary.asr && (
                    <span className="ms-3">
                      <strong>ASR:</strong> {summary.asr}
                    </span>
                  )}
                  {summary.acd && (
                    <span className="ms-3">
                      <strong>ACD:</strong> {summary.acd}
                    </span>
                  )}
                </div>
                <div>
                  <strong>Charge:</strong>{' '}
                  {summary.client_cost || summary.vendor_cost || '0.00'}$
                </div>
              </div>

              {details.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Called number</th>
                      <th>Date</th>
                      <th>Rate, $</th>
                      <th>Duration</th>
                      <th>Charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.map((call, idx) => (
                      <tr key={idx}>
                        <td>+{call.called_number}</td>
                        <td>{formatDate(call.disconnect_time)}</td>
                        <td>{parseFloat(call.rate || 0).toFixed(5)} / min</td>
                        <td>{formatDuration(call.duration)}</td>
                        <td>{parseFloat(call.charge || 0).toFixed(5)}$</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center text-muted p-4">
                  No data for this period
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CallsHistory;
